// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tracking-badge.v-chip[data-v-c96372ec]{height:16px;border-radius:12px;pointer-events:none;padding:0 var(--spacer-xxs);font-size:10px;line-height:12px;letter-spacing:1px;font-weight:var(--font-weight-medium);text-transform:uppercase}.tracking-badge--is-locked[data-v-c96372ec]{background-color:var(--v-blue-primary)!important;color:var(--v-white)}.tracking-badge--is-updated[data-v-c96372ec]{background-color:var(--v-orange-warning)!important;color:var(--v-white)}", ""]);
// Exports
module.exports = exports;
